import { ActionLabels, buttonLabels, emptyLabels, pageTitles, ToasterTexts } from "../shared/constants"
import { AddNumberIcon, CancelWhiteIcon, DeleteChatIcon, EditIcon, MultiSelectCrossIcon } from "../../icon"
import { ActionsRenderer } from "../shared/grid/actionsRenderer"
import { ColDef, ColumnApi, GridApi, ICellRendererParams, ValueGetterParams } from "ag-grid-community"
import GridComponent from "../shared/grid"
import { useSelector } from "react-redux"
import { maptoPhoneNumberGroups, PhoneNumbergroup, PhoneNumberModel } from "../../models/phone-number.model"
import * as selector from "../../selectors/selectors"
import { useEffect, useState } from "react"
import { setHeaderCount, setHeaderTitle, setRefreshHandler, setSelectedCount } from "../../helpers/header.helper"
import { LoadNewOrganizations, LoadOrganizations, LoadPhoneNumberGroups } from "../../actions"
import { useDispatch } from "react-redux"
import { UserService } from "../../services/UserService"
import { PhoneNumberGroupService } from "../../services/PhoneNumberGroupsServices"
import { OrganizationModel } from "../../models/organization.model"
import PageHeaderComponent from "../shared/page-header.component"
import { updateOrganizationPhoneNumberGroups, updatePhoneGroupsSelectedOrgIDs, updatePhonenumberSelectedOrgIDs } from "../../reducers/reducer"
import PhoneGroupView from "./PhoneNumberGroupView.component";
import ConfirmDialog from "../shared/confirm-dialog.component";
import { Dialog, DialogContent, DialogTitle, Tooltip } from "@mui/material"
import { LocalStorage, UtilityService } from "../../services/UtilityService"
import { Role } from "../../models/roles.model"
import { UserModel } from "../../models/users.model"
import setToast from "../../helpers/toaster.helper"
import { ToasterType } from "../shared/toaster/toaster.model"




interface IProps {
    show: boolean;
    setShow: () => void;
    GridApi: GridApi;
    OnGridReady: (params: any) => void;
}

const PhoneNumberGroups = (props: IProps) => {

    const dispatch = useDispatch();

    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const PhoneNumberGroups: PhoneNumbergroup[] = useSelector(selector.phonenumbergroups);
    const organizationId = UserService.getCurrentUserOrgId();
    const OrganizationPhoneNumberGroups = useSelector(selector.OrganzationPhoneNumberGroups);
    const SelectedOrganizations: string[] = useSelector(selector.SelectedPhoneGroupOrganizations)
    const PhoneNumbers: PhoneNumberModel[] = useSelector(selector.phoneNumbers);
    const Organizations: OrganizationModel[] = useSelector(selector.organizations);
    const newOrganizations: OrganizationModel[] = useSelector(selector.newOrganizations);
    const Users: UserModel[] = useSelector(selector.users)

    const [gridApi, setGridApi] = useState<GridApi>(props.GridApi);
    const [columnApi, setColumnApi] = useState<ColumnApi>(null)
    const [ShowMultiActionButtons, setShowMultiActionButtons] = useState<boolean>(false)
    const [selectedOrgIds, setSelectedOrgIds] = useState<string[]>([]);
    const [searchValue, setSearchValue] = useState<any>();
    const [clickRowId, setClickRowId] = useState<string>("")
    const [GrouptoEdit, setGrouptoEdit] = useState<PhoneNumbergroup>()
    const [confirm, setConfirm] = useState<boolean>(false)
    const [RowData, setRowData] = useState<PhoneNumbergroup[]>()
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [show, setShow] = useState<boolean>(false)
    const [phoneNumbers, setPhonenumbers] = useState<{ phoneNumberId: string, phoneNumber: string, phoneNumberName: string }[]>()
    const [phonedailog, setPhonedailog] = useState<boolean>(false);


    let PhoneGroupsColoumnDefs: ColDef[] = [
        {
            field: "Name",
            headerName: "Name",
            valueGetter: (params: ValueGetterParams) => {
                if (params.data) {
                    return `${params.data.GroupName}`
                }
            },
            cellStyle: { display: "flex", alignItems: "center", overflow: 'hidden', textOverflow: 'ellipsis' },
        },
        {
            field: "Phone Number",
            headerName: "Phone Number",
            valueGetter: (params: ValueGetterParams) => {
                return params.data?.PhoneNumbers?.length || 0; // just the count
            },
            cellRenderer: (params: ICellRendererParams) => {
                return (
                    <div onClick={() => handlePhoneDialog(true, params.data?.PhoneNumbers)} className="color-vigenary-light">
                        {params.data.PhoneNumbers?.length || 0}
                    </div>
                );
            },
            cellClass: "c-pointer",
            suppressSizeToFit: true,
        },
        {
            field: "Created On",
            headerName: "Created On",
            valueGetter: (params: ValueGetterParams) => UtilityService.convertDateToDay(params.data.CreatedDateTime).toString(),
            suppressSizeToFit: true,

        },
        {
            field: "Action",
            maxWidth: 40,
            headerName: "",
            pinned: "right",
            lockPinned: true,
            lockPosition: "right",
            cellClass: "ag-cell-actions-style",
            headerClass: "bg-color-secondary",
            cellRenderer: params => <ActionsRenderer
                MenuData={[
                    {
                        Name: ActionLabels.EDIT,
                        Icon: EditIcon,
                        OnClick: () => { EditGroup(params.data.Id, params.data) }
                    },
                    {
                        Name: ActionLabels.DELETE,
                        Icon: DeleteChatIcon,
                        OnClick: () => handleConfirmDialog(params.data),
                        Hide: UserService.getLoggedInUserRole() === Role.MANAGER,
                    },
                ]}
                {...params}
            />,
            resizable: false,
            sortable: false,
        },
    ]


    useEffect(() => {
        setShow(props.show)
    }, [props.show])

    useEffect(() => {
        if (UserService.getLoggedInUserRole() === Role.MANAGER) {
            const phoneNumberGroups = LocalStorage.get("current-user")?.phoneNumberGroups.map(x => x.id)
            setRowData(PhoneNumberGroups.filter(x => phoneNumberGroups.includes(x.Id)))
            setHeaderCount(phoneNumberGroups?.length || 0)
        }
        else {
            setRowData(PhoneNumberGroups)
            setHeaderCount(PhoneNumberGroups?.length || 0)
        }

    }, [PhoneNumberGroups])

    useEffect(() => {
        if (UserService.hasOrgAdminRole() || UserService.hasManagerRole()) {
            LoadPhoneNumberGroups(dispatch, organizationId);
        }
        if (UserService.hasSysAdminRole) {
            LoadOrganizations(dispatch);
            LoadNewOrganizations(dispatch);

        }
        return () => {
            setSelectedCount(0)
        }
    }, [])

    useEffect(() => {
        setHeaderTitle(pageTitles.LINE_GROUPS);
        setHeaderCount(PhoneNumberGroups?.length || 0)
        setRefreshHandler(gridRefresh);
        return setHeaderTitle
    }, [gridApi, columnApi])

    useEffect(() => {
        if (selectedOrgIds.length === 0) {
            setShowMultiActionButtons(false)
            if (UserService.hasSysAdminRole()) {
                setRowData([])
            }
        }
        else {
            setShowMultiActionButtons(true)
        }

    }, [selectedOrgIds])

    useEffect(() => {
        if (UserService.hasSysAdminRole()) {
            setSelectedOrgIds(SelectedOrganizations);
            if (!!SelectedOrganizations?.length) {
                setRowData(OrganizationPhoneNumberGroups)
            }
        }
    }, [gridApi, Organizations])


    const EditGroup = (rowId, data) => {
        setShow(true)
        setClickRowId(rowId);
        setGrouptoEdit(data);
    }

    const gridRefresh = () => {
        if (UserService.hasSysAdminRole() && !!selectedOrgIds) {
            console.log(selectedOrgIds, "selectedOrgIds")
            getPhoneNumbersGroups(selectedOrgIds)
        }
        else {
            LoadPhoneNumberGroups(dispatch, organizationId);
        }
        if (!!columnApi) {
            columnApi.resetColumnState()
        }

        if (!!gridApi) {
            gridApi.refreshCells({ force: true })
        }

        // setSelectedOrgIds(SelectedOrganizations)

    }

    const onGridReady = (params) => {
        setGridApi(params.api)
        setColumnApi(params.columnApi)
    }

    const getPhoneNumbersGroups = (ids) => {
        if ((PhoneNumberGroups.length === 0 || ids.length > 0) && !!gridApi) {
            gridApi.showLoadingOverlay();
        }
        PhoneNumberGroupService.getGridByOrganizations(ids).then((res => {
            setRowData(res.data.map(maptoPhoneNumberGroups))
            dispatch(updateOrganizationPhoneNumberGroups(res.data.map(maptoPhoneNumberGroups)))
        })).catch()

    }

    const clearSelection = () => {
        if (!!gridApi && !!PhoneNumbers.length)
            gridApi.deselectAll();

        if (!!RowData.length || !!selectedOrgIds.length) {
            setShowMultiActionButtons(false)
            setSelectedOrgIds([])
            if (UserService.hasSysAdminRole()) {
                setRowData([])
                setHeaderCount(0)
            }
            dispatch(updatePhoneGroupsSelectedOrgIDs([]))
            dispatch(updateOrganizationPhoneNumberGroups([]))

        }
    }

    const handleConfirmDialog = (data: any) => {
        const Managersingroup = Users.filter(x => x.PhoneNumberGroups.map(x => x.Id).includes(data.Id)).some(y => y.RoleID === Role.MANAGER)
        if (Managersingroup) {
            setToast(`You cannot Delete this group as the phonenumber is assigned to manager`, ToasterType.DANGER)
            setConfirm(false)
        } else {
            setConfirm(true)
        }
        setClickRowId(data.Id);
    }

    const handleCloseConfirmDailog = (isconfirm: boolean,) => {
        if (!!isconfirm) {
            setIsLoading(true)
            let data = RowData.find((x: PhoneNumbergroup) => x.Id === clickRowId);
            PhoneNumberGroupService.deletePhoneNumberGroup(data.OrganizationID, data.Id).then((res) => {
                setIsLoading(false)
                // LoadPhoneNumberGroups(dispatch, data.OrganizationID)
                setConfirm(false)
                if (UserService.hasSysAdminRole() && !!selectedOrgIds?.length) {
                    getPhoneNumbersGroups(selectedOrgIds)
                }
                setToast(ToasterTexts.PHONENUMBER_GROUP_DELETE_SUCCESS, ToasterType.SUCCESS)

            }).catch((err) => {
                setConfirm(false)
                setIsLoading(false)
            })
        }
        else {
            setConfirm(false)
            setIsLoading(false)
        }
    }

    const searchPhoneNumberGroup = (e) => {
        setSearchValue(e.target.value)
        gridApi?.setQuickFilter(e.target.value)
    }
    const createPhoneGroup = () => {
        setShow(true)
    }

    const handleClose = (isConfim: boolean) => {
        setShow(false)
        setGrouptoEdit(undefined)
        if (props.setShow) {
            props.setShow()
        }
        if (!!isConfim) {
            if (UserService.hasSysAdminRole()) {
                getPhoneNumbersGroups(selectedOrgIds)
            }
            else {
                LoadPhoneNumberGroups(dispatch, organizationId)
            }
        }
    }

    const handlePhoneDialog = (value, data) => {
        setPhonedailog(value)
        setPhonenumbers(data)
    }

    return (
        <div className="d-flex flex-direction h-p-100 o-hidden justify-between" >
            {UserService.hasSysAdminRole() &&
                <PageHeaderComponent
                    GridTitle={""}
                    Count={PhoneNumberGroups.length}
                    Actions={[{
                        OnClick: () => createPhoneGroup(),
                        ButtonLabel: buttonLabels.CREATE_LINE_GROUP,
                        Icon: AddNumberIcon,
                        Variant: "primary-btn",
                    }]}
                    ShowMultiActionButtons={ShowMultiActionButtons}
                    MultiActionButtons={[
                        {
                            Name: buttonLabels.APPLY,
                            Variant: "primary",
                            ClassName: "mr-2",
                            Hide: !UserService.hasSysAdminRole(),
                            OnClick: () => { getPhoneNumbersGroups(selectedOrgIds) }
                        },
                        {
                            Name: ActionLabels.CLEAR_SELECTION,
                            Variant: "text",
                            ClassName: "p-0 mr-1 w-space",
                            Icon: MultiSelectCrossIcon,
                            Hide: false,
                            OnClick: () => clearSelection()
                        }
                    ]}
                    ShowFilterIcon={false}
                    onSearch={(e) => searchPhoneNumberGroup(e)}
                    searchValue={searchValue}
                    PlaceHolder={"Find a Line Groups..."}
                    showAutoComplete={true}
                    autoCompleteOptions={[...(Organizations ?? []), ...(newOrganizations ?? [])]?.filter(x => (x.Name !== null && !x.IsDeleted))}
                    onChangeAutoComplete={(ids) => {
                        setSelectedOrgIds(ids);
                        dispatch(updatePhoneGroupsSelectedOrgIDs(ids))
                        dispatch(updateOrganizationPhoneNumberGroups([]));

                    }}
                    autoCompleteValue={selectedOrgIds}
                />}
            {
                <GridComponent
                    ColumnDefs={PhoneGroupsColoumnDefs}
                    RowData={RowData}
                    OnGridReady={UserService.hasSysAdminRole() ? onGridReady : props.OnGridReady}
                    // OnGridRowClick={handleRowClick}
                    IsPaginationEnabled={true}
                    gridApi={gridApi}
                    EmptyLabel={emptyLabels.PHONENUMBER_GROUPS}
                    LockVisible={IsMobileDevice}
                />
            }
            {

                show &&
                <PhoneGroupView
                    group={GrouptoEdit}
                    handleclose={handleClose}
                    show={show}
                />

            }

            {
                confirm && <ConfirmDialog
                    ButtonName={"Delete"}
                    onClose={handleCloseConfirmDailog}
                    Show={confirm}
                    Text={"Do you want to Delete the Line Group?"}
                    Loading={isLoading}
                />
            }
            {phonedailog &&
                <Dialog
                    open={phonedailog}
                    onClose={() => handlePhoneDialog(false, null)}
                    maxWidth="xs"
                    fullWidth
                >
                    <DialogTitle className=" d-flex justify-between align-center px-2 py-1 my-auto bg-color-primary-light">
                        <span className="h4-regular color-secondary">Phone Numbers</span>
                        <Tooltip title="Close" placement="bottom">
                            <CancelWhiteIcon onClick={() => handlePhoneDialog(false, null)} className="c-pointer" />
                        </Tooltip>
                    </DialogTitle>
                    <DialogContent  >
                        <div className="groupchat-info-background groupchat-info-border br-1 mt-2">
                            <div className="py-1 px-2 o-y-scroll h-v-30">
                                <div className="d-flex justify-between h4-regular ">
                                    <div className="w-20">Name</div>
                                    <div className="w-20">Phone Number</div>
                                </div>
                                {phoneNumbers.map((x, index) => (
                                    <div className="py-1 d-flex justify-between h6-regular ">
                                        <div className="w-20 w-break">{UtilityService.trimMessage(x.phoneNumberName, 15)}</div>
                                        <div className="w-20">{UtilityService.maskPhoneNumberOnLength(x.phoneNumber)}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </DialogContent>
                </Dialog>
            }
        </div>
    )
}
export default PhoneNumberGroups;